import { Button, ButtonProps } from '@zorro/design-system/v2/Button';
import { Group, IPaperProps, Paper } from '@zorro/web/design-system';
import { ReactNode } from 'react';

export type FooterProps = {
  primaryLabel?: string;
  secondaryLabel?: string;
  secondaryButtonProps?: ButtonProps;
  /** Renders this instead of the default secondary `Button`. Use when the secondary action needs to be a custom component (e.g. one that owns its own click handling). */
  secondaryButton?: ReactNode;
  primaryButtonProps?: ButtonProps;
  tertiaryLabel?: string;
  tertiaryButtonProps?: ButtonProps;
  paperProps?: Omit<IPaperProps, 'children'>;
  /** When true, renders only the button group without the Paper wrapper.
   *  Use this when passing FormFooter to the V2 Drawer `footer` prop. */
  withPaper?: boolean;
};

export const FormFooter = ({
  primaryButtonProps,
  secondaryButtonProps,
  secondaryButton,
  tertiaryButtonProps,
  primaryLabel,
  secondaryLabel,
  tertiaryLabel,
  paperProps,
  withPaper = true,
}: FooterProps) => {
  if (!secondaryLabel && !primaryLabel && !tertiaryLabel && !secondaryButton) {
    return null;
  }

  const buttons = (
    <Group justify="flex-end" w="100%" wrap="nowrap">
      {tertiaryLabel && (
        <Button size="lg" variant="tertiary" {...tertiaryButtonProps}>
          {tertiaryLabel}
        </Button>
      )}
      {secondaryButton ||
        (secondaryLabel && (
          <Button size="lg" variant="secondary" {...secondaryButtonProps}>
            {secondaryLabel}
          </Button>
        ))}
      {primaryLabel && (
        <Button size="lg" {...primaryButtonProps}>
          {primaryLabel}
        </Button>
      )}
    </Group>
  );

  if (!withPaper) {
    return buttons;
  }

  return (
    <Paper
      pos="fixed"
      right={0}
      bottom={0}
      shadow="0px -4px 24.6px 0px rgba(0, 0, 0, 0.04)"
      w="100%"
      py="md"
      pr="xl"
      pl="lg"
      display="flex"
      style={{ zIndex: 1, marginTop: 'auto' }}
      {...paperProps}
    >
      {buttons}
    </Paper>
  );
};
